<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Principal's Message</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Principal's Message</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- teacher details widget start here-->
        <section class="bd-teacher-widget-area pb-70 pt-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <div class="bd-teacher-widget-thumb p-relative">
                                <img src="/img/general/PRINCIPAL PIC.jpeg" alt="img not found!" style="height: 750px;">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-teacher-widget-content">
                                <h3 class="bd-teacher-widget-title">Dr. Seema Rathore</h3>
                                <span class="bd-teacher-widget-tag">Senior Principal, Vedanta Gurukul School, Reengus</span>
                                <p>Education is not merely the acquisition of knowledge; it is the foundation for building character, nurturing values, and empowering young minds to become responsible and confident citizens.
At Vedanta Gurukul School, we believe that every child is unique and possesses immense potential. Our endeavour is to provide a nurturing, inclusive, and stimulating learning environment where students are encouraged to think critically, explore creatively, develop leadership skills, and pursue excellence in every sphere of life.
</p>
                                <p>We are committed to a holistic approach to education that integrates academic excellence with moral values, discipline, sports, cultural activities, and life skills. Through the collective efforts of our dedicated teachers, supportive parents, and enthusiastic students, we strive to create an atmosphere where learning becomes meaningful, joyful, and purposeful.</p>
                                <p>As we move forward, our vision is to strengthen the foundations of quality education, embrace innovative teaching practices, and prepare our students to meet the challenges of an ever-changing world with confidence, compassion, and integrity.</p>
                                <p>I firmly believe that education is a shared journey, where the school, parents, and community work together to shape a brighter future for every child.
Let us continue to inspire young minds, celebrate every achievement, and empower our children to dream big, work hard, and make a positive difference in society.<br>With warm wishes and best regards,

</p>
<p>Dr. Seema Rathore<br>
Senior Principal<br>
Vedanta Gurukul School, Reengus</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- teacher details widget end here-->

    </main>
</template>
<script>
export default {
    name: "LeadershipMessageView",
};
</script>
